export default "__VITE_ASSET__CV_YUswA__"